// redux/slices/psnSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generalDetails: null,
  soldToShipToDetails: null,
  priceBreakdownDetails: null,
};

const psnSlice = createSlice({
  name: "psn",
  initialState,
  reducers: {
    setGeneralDetails: (state, action) => {
      state.generalDetails = action.payload;
    },
    setSoldToShipToDetails: (state, action) => {
      state.soldToShipToDetails = action.payload;
    },
    setPriceBreakdownDetails: (state, action) => {
      state.priceBreakdownDetails = action.payload;
    },
  },
});

export const {
  setGeneralDetails,
  setSoldToShipToDetails,
  setPriceBreakdownDetails,
} = psnSlice.actions;

export default psnSlice.reducer;
